// extracted by mini-css-extract-plugin
export default {"pageWrap":"eb-z","fullWidth":"fb-z","heading":"gb-z","fullBleed":"hb-z","hidden":"ib-z"};